import { CommonResponseModel, driverIdReq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class DepartmentService extends CommonAxiosService {
    private DepartmentController = "/department";

    async createDepartment(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.DepartmentController + "/createDepartment", payload)
    }

    async getAllDepartments(payload?:driverIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.DepartmentController + "/getAllDepartments", payload)
    }

    async getActiveAllDepartments(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.DepartmentController + "/getActiveAllDepartments")
    }
    async updateDepartment(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.DepartmentController + '/updateDepartment', dto)
    }

    async activateOrDeactivateDepartment(payload: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.DepartmentController + "/activateOrDeactivateDepartment", payload)
    }

}